{
  "dismiss": "閉じる"
}
